import { useState, useEffect } from 'react';

/**
 * Hook for detecting and reacting to dark mode changes
 * Watches for changes to the 'dark' class on the document element
 */
export function useDarkMode(): boolean {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Initialize with current dark mode state
    if (typeof document !== 'undefined') {
      return document.documentElement.classList.contains('dark');
    }
    return false;
  });

  useEffect(() => {
    const checkDarkMode = () => {
      const htmlElement = document.documentElement;
      const newIsDarkMode = htmlElement.classList.contains('dark');
      setIsDarkMode(newIsDarkMode);
    };

    // Initial check (in case state is out of sync)
    checkDarkMode();

    // Set up observer to watch for dark mode changes
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
        ) {
          checkDarkMode();
        }
      });
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });

    return () => observer.disconnect();
  }, []);

  return isDarkMode;
}
